import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCancellationPolicy,
  fetchHouseRules,
  fetchPrivacyPolicy,
  fetchTermsAndConditions,
  updateCancellationPolicyThunk,
  updateHouseRulesThunk,
  updatePrivacyPolicyThunk,
  updateTermsAndConditionsThunk,
} from "./thunk";

const initialState = {
  cancellationPolicy: { data: null, loading: false },
  privacyPolicy: { data: null, loading: false },
  termsPolicy: { data: null, loading: false },
  houseRules: { data: null, loading: false },
};

const staticPagesSlice = createSlice({
  name: "staticPages",
  initialState,
  reducers: {
    resetCancellationPolicyFlag(state) {
      state.cancellationPolicy.loading = false;
    },
    resetPrivacyPolicyFlag(state) {
      state.privacyPolicy.loading = false;
    },
    resetTermsAndConditionsFlag(state) {
      state.termsPolicy.loading = false;
    },
    resetHouseRulesFlag(state) {
      state.houseRules.loading = false;
    },
  },

  extraReducers: (builder) => {
    // Cancellation
    builder
      .addCase(fetchCancellationPolicy.pending, (state) => {
        state.cancellationPolicy.loading = true;
      })
      .addCase(fetchCancellationPolicy.fulfilled, (state, action) => {
        state.cancellationPolicy.loading = false;
        state.cancellationPolicy.data = action.payload.data || null;
      })
      .addCase(updateCancellationPolicyThunk.fulfilled, (state, action) => {
        state.cancellationPolicy.data = action.payload.data || null;
      });

    // Privacy
    builder
      .addCase(fetchPrivacyPolicy.pending, (state) => {
        state.privacyPolicy.loading = true;
      })
      .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
        state.privacyPolicy.loading = false;
        state.privacyPolicy.data = action.payload.data || null;
      })
      .addCase(updatePrivacyPolicyThunk.fulfilled, (state, action) => {
        state.privacyPolicy.data = action.payload.data || null;
      });

    // Terms & Conditions
    builder
      .addCase(fetchTermsAndConditions.pending, (state) => {
        state.termsPolicy.loading = true;
      })
      .addCase(fetchTermsAndConditions.fulfilled, (state, action) => {
        state.termsPolicy.loading = false;
        state.termsPolicy.data = action.payload.data || null;
      })
      .addCase(updateTermsAndConditionsThunk.fulfilled, (state, action) => {
        state.termsPolicy.data = action.payload.data || null;
      });

    // House Rules
    builder
      .addCase(fetchHouseRules.pending, (state) => {
        state.houseRules.loading = true;
      })
      .addCase(fetchHouseRules.fulfilled, (state, action) => {
        state.houseRules.loading = false;
        state.houseRules.data = action.payload.data || null;
      })
      .addCase(updateHouseRulesThunk.fulfilled, (state, action) => {
        state.houseRules.data = action.payload.data || null;
      });
  },
});

export const {
  resetCancellationPolicyFlag,
  resetPrivacyPolicyFlag,
  resetTermsAndConditionsFlag,
  resetHouseRulesFlag,
} = staticPagesSlice.actions;

export default staticPagesSlice.reducer;
